/** Parses CSV into rows of cells.
 *
 *  Handles the two things a split on delimiters gets wrong: a comma inside a
 *  quoted field, and a newline inside one. Both occur in extracted CEM tables —
 *  a parameter named "Treatment (acquisition, administration, adverse events)"
 *  splits into three cells and shifts every column after it, and a header
 *  written with Alt+Enter in Excel arrives as a quoted field containing a line
 *  break.
 *
 *  Scanned character by character rather than line by line, because a row does
 *  not necessarily end at the first newline.
 */
export function parseCsv(raw: string): string[][] {
  const rows: string[][] = [];
  let row: string[] = [];
  let cell = "";
  let quoted = false;

  const endCell = () => {
    row.push(cell);
    cell = "";
  };
  const endRow = () => {
    endCell();
    if (row.some((value) => value !== "")) rows.push(row);
    row = [];
  };

  for (let i = 0; i < raw.length; i++) {
    const char = raw[i];

    if (quoted) {
      if (char === '"' && raw[i + 1] === '"') {
        cell += '"';
        i++;
      } else if (char === '"') {
        quoted = false;
      } else {
        cell += char;
      }
      continue;
    }

    if (char === '"') quoted = true;
    else if (char === ",") endCell();
    else if (char === "\r") continue;
    else if (char === "\n") endRow();
    else cell += char;
  }

  if (cell !== "" || row.length > 0) endRow();
  return rows;
}
